var a="\n#define SHADOWBIAS\n\nfloat getShadowBias(float resolution, float maxBias) {\n    return maxBias;\n}\n";export{a as default};
